import { transport } from 'config/transport';

export function callApiUpdateClass(classId, body) {
    return transport.put(`/mamnon/classes/${classId}`, body);
}
